module.exports = __webpack_public_path__ + "img/edit-product.ba1516e2.png";